// VFX: Heatmap Grid
// Category: data-viz · Tags: heatmap, grid, data, glow, loop
// Color-coded grid cells pulse to represent data density.
import { AbsoluteFill, useCurrentFrame } from "remotion";
import React from "react";

const COLS = 12;
const ROWS = 20;

function heatColor(t: number) {
  // 0 → dark blue, 0.5 → purple, 1 → orange/red
  if (t < 0.33) return `rgba(6,182,212,${0.15 + t * 1.5})`;
  if (t < 0.66) return `rgba(168,85,247,${0.25 + (t - 0.33) * 1.5})`;
  return `rgba(249,115,22,${0.4 + (t - 0.66) * 1.5})`;
}

export default function DataHeatmapGridGlowLoop() {
  const frame = useCurrentFrame();

  return (
    <AbsoluteFill style={{
      background: "#0a0e1a",
      padding: 40, display: "grid",
      gridTemplateColumns: `repeat(${COLS}, 1fr)`,
      gridTemplateRows: `repeat(${ROWS}, 1fr)`,
      gap: 6,
    }}>
      {Array.from({ length: COLS * ROWS }).map((_, idx) => {
        const c = idx % COLS;
        const r = Math.floor(idx / COLS);
        const base = (Math.sin(c * 0.7 + r * 0.5) + 1) / 2;
        const pulse = (Math.sin(frame * 0.08 + c * 0.3 + r * 0.2) + 1) / 2;
        const intensity = base * 0.5 + pulse * 0.5;
        const color = heatColor(intensity);
        return (
          <div key={idx} style={{
            background: color,
            borderRadius: 4,
            boxShadow: intensity > 0.7 ? `0 0 ${intensity * 18}px ${color}` : "none",
            transition: "background 0.1s",
          }} />
        );
      })}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
